import React from 'react';
import {
  Paper,
  Box,
  Container,
  FormControl,
  Divider,
  Stack,
  DialogContentText,
  Button
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { Autocomplete, Datas, AprovacoesCheckbox } from '../../../components';
import api from '../../../services/api';
import Dados from './Dados';
import { tagsRel } from './constants';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { CSVDownload } from 'react-csv';
import { removerQuebrasDeLinha } from '../../../utils/removerQuebraDeLinha';

const Tema02 = () => {
  let startLoading = useStoreActions(actions => actions.nav.startLoading);
  let stopLoading = useStoreActions(actions => actions.nav.stopLoading);
  let user = useStoreState(state => state.auth.user);

  const [empresas, setEmpresas] = React.useState([]);
  const [ano, setAno] = React.useState(new Date().getFullYear() - 1);
  const [csvData, setCsvData] = React.useState([]);

  const schema = yup
    .object({
      empresaId: yup.number().nullable().label('Empresas').required()
    })
    .required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema)
  });

  const {
    handleSubmit,
    reset,
    watch,
    formState: { isDirty, isSubmitting }
  } = useFormRef;

  const watchEmpresaId = watch('empresaId');

  const loadEmpresas = async mount => {
    startLoading();
    try {
      let data = (
        await api.http.get(
          '/empresas/' +
            (user.roleId == 'admin' ? '?all=1&matriz=1' : '?matriz=1')
        )
      ).data;
      if (mount.isMounted) setEmpresas(data);
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
      throw error;
    }
  };
  React.useEffect(() => {
    let mount = {
      isMounted: true
    };
    loadEmpresas(mount);
    return () => {
      mount.isMounted = false;
    };
  }, []);

  function onChangeAno(event, ano) {
    setAno(ano);
  }

  function extrairDataHora(dateTimeStr) {
    const dateObj = new Date(dateTimeStr);
    const year = dateObj.getFullYear().toString();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const day = dateObj.getDate().toString().padStart(2, '0');
    const date = `${day}-${month}-${year}`;
    const hours = dateObj.getHours().toString().padStart(2, '0');
    const minutes = dateObj.getMinutes().toString().padStart(2, '0');
    const seconds = dateObj.getSeconds().toString().padStart(2, '0');
    const time = `${hours}:${minutes}:${seconds}`;
    return date + ' ' + time;
  }

  function extrairData(dateStr) {
    const date = new Date(dateStr);
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    return `${month}/${year}`;
  }
  function boolean(number) {
    switch (number) {
      case 1:
        return 'SIM';
      case 2:
        return 'NÃO';
      default:
        return '';
    }
  }
  function tipoImplant(number) {
    switch (number) {
      case 1:
        return 'Implantação Parcial';
      case 2:
        return 'Implantação Total';
      default:
        return '';
    }
  }
  function nivelHierarquico(number) {
    switch (number) {
      case 1:
        return 'CEO';
      case 2:
        return 'Vice Presidente';
      case 3:
        return 'Diretor';
      case 4:
        return 'Gerente';
      case 5:
        return 'Coordenador';
      case 6:
        return 'Engenheiro';
      default:
        return '';
    }
  }

  const exportDados = async () => {
    startLoading();
    try {
      const dados = (await api.http.get('/02/gestao-rejeitos')).data;
      console.log(dados);
      const dadosCsv = dados.map(data => {
        return {
          cnpj: data?.empresa?.cnpj,
          empresa: removerQuebrasDeLinha(data?.empresa?.nome),
          ano: data?.ano,
          fezAdesaoProx: data?.fezAdesaoProx
            ? boolean(data.fezAdesaoProx)
            : null,
          planejaAdesaoProx: data?.planejaAdesaoProx
            ? boolean(data.planejaAdesaoProx)
            : null,
          quandoPlanejaAdesaoProx: data?.quandoPlanejaAdesaoProx
            ? extrairData(data.quandoPlanejaAdesaoProx)
            : null,
          planejamentoGestaoRejeitos: data?.planejamentoGestaoRejeitos
            ? boolean(data.planejamentoGestaoRejeitos)
            : null,
          tipoDeImplantacao: data?.tipoDeImplantacao
            ? tipoImplant(data.tipoDeImplantacao)
            : null,
          prevInicioImplantacao: data?.prevInicioImplantacao
            ? extrairData(data.prevInicioImplantacao)
            : null,
          prevFinalizacaoImplantacao: data?.prevFinalizacaoImplantacao
            ? extrairData(data.prevFinalizacaoImplantacao)
            : null,
          mediaParaEstruturas: data?.mediaParaEstruturas,
          tipoGapAssessment: data?.tipoGapAssessment
            ? boolean(data.tipoGapAssessment)
            : null,
          definiuExecutivoResp: data?.definiuExecutivoResp
            ? boolean(data.definiuExecutivoResp)
            : null,
          nivelHierarquicoProfissional: data?.nivelHierarquicoProfissional
            ? nivelHierarquico(data.nivelHierarquicoProfissional)
            : null,
          implementouCirrItrb: data?.implementouCirrItrb
            ? boolean(data.implementouCirrItrb)
            : null,
          prevFinalizacaoImplementacao: data?.prevFinalizacaoImplementacao
            ? extrairData(data.prevFinalizacaoImplementacao)
            : null,
          observacoes: removerQuebrasDeLinha(data?.observacoes),
          createdAt: data.createdAt ? extrairDataHora(data.createdAt) : null,
          updatedAt: data.updatedAt ? extrairDataHora(data.updatedAt) : null
        };
      });

      if (dadosCsv.length == 0) {
        stopLoading({
          message: 'Nenhum registro encontrado.',
          severity: 'error'
        });
      } else {
        setCsvData([tagsRel, ...dadosCsv]);
        stopLoading();
      }
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };

  return (
    <Container>
      <Paper
        variant="outlined"
        className="center-box"
        sx={{
          textAlign: 'center',
          px: 4,
          pt: 2,
          pb: 3,
          m: 5
        }}
      >
        <Divider>
          <h3>Dados básicos</h3>
        </Divider>
        <Box component="form">
          <Stack direction="row" spacing={2}>
            <FormControl fullWidth>
              <Autocomplete
                field="empresaId"
                useFormRef={useFormRef}
                options={empresas}
                getOptionLabel={empresa =>
                  empresa.nome + ' (' + empresa.cnpj + ')'
                }
                schema={schema}
              />
            </FormControl>
            <Datas onChange={onChangeAno} value={ano} />
          </Stack>
          <Stack direction="row" spacing={2}>
            <AprovacoesCheckbox />
          </Stack>
          {['admin', 'gestor', 'preenchedorSso'].includes(user.roleId) && (
            <Stack direction="row" spacing={2} mt={2}>
              <Button
                variant="contained"
                onClick={exportDados}
                sx={{ height: 45 }}
              >
                <FileDownloadIcon /> Exportar Dados (CSV)
              </Button>
              {csvData && csvData.length > 0 && (
                <CSVDownload
                  data={csvData}
                  headers={tagsRel.headers}
                  separator=";"
                  target="_blank"
                />
              )}
            </Stack>
          )}
        </Box>
      </Paper>

      {watchEmpresaId > 0 && (
        <Paper
          variant="outlined"
          className="center-box"
          sx={{
            textAlign: 'center',
            px: 4,
            pt: 2,
            pb: 3,
            m: 5
          }}
        >
          <Divider>
            <h3>PROX</h3>
          </Divider>
          <DialogContentText sx={{ mb: 3 }}>
            Observação: todos os dados abaixo devem ser preenchidos com os
            valores totais (integralizados) no ano de referência selecionado
            acima.
          </DialogContentText>
          <Dados watchEmpresaId={watchEmpresaId} ano={ano} />
        </Paper>
      )}
    </Container>
  );
};

export default Tema02;
